import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import qs from 'query-string';

import ArrowSvg from '../../assets/arrow-down.svg';

import W from '../styled/Wrapper';
import S from '../styled/Select';

const Wrapper = styled(W)`
  display: flex;
  width: 100%;
  background-color: ${({ theme }) => theme.colorBg};
  box-shadow: 0 0 30px 25px ${({ theme }) => theme.colorBg};
  position: fixed;
  top: 62px;
  left: 0;
  right: 0;
  z-index: 1;
  padding-top: 20px;
  width: 100%;

  @media only screen and (max-width: 810px) {
    top: 50px;
    padding-top: 5px;
  }
`;

const SizeButton = styled.button`
  margin-left: auto;
  display: flex;
  padding-top: 5px;
`;

const SizeButtonInner = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 30px;
  height: 21px;
  margin-left: 21px;

  @media only screen and (max-width: 810px) {
    width: 25px;
    height: 15px;
    margin-left: 15px;
  }
`;

const Bar = styled.span`
  height: ${({ size }) => (size === 's' ? '1px' : '5px')};
  width: 100%;
  background-color: ${({ theme }) => theme.colorMain};

  @media only screen and (max-width: 810px) {
    display: ${({ mob }) => (mob ? 'block' : 'none')};
  }
`;

const BottomGradient = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 2px;
  box-shadow: 0 0 35px 30px ${({ theme }) => theme.colorBg};
  background-color: ${({ theme }) => theme.colorBg};
`;

const SelectWrapper = styled.div`
  position: relative;
  padding-right: 20px;
  margin-right: 80px;
  font-size: 24px;
  line-height: 1;

  @media only screen and (max-width: 810px) {
    margin-right: 30px;
  }
`;

const Arrow = styled(ArrowSvg)`
  position: absolute;
  right: 0;
  top: 7px;

  path,
  rect {
    fill: ${({ theme }) => theme.colorMain} !important;
  }
`;

const Label = styled.span`
  pointer-events: none;
  text-transform: uppercase;

  @media only screen and (max-width: 810px) {
    font-size: 16px;
    line-height: 19px;
  }
`;

const Select = styled(S)`
  position: absolute;
  opacity: 0;
  width: 100%;
  height: 30px;
  top: 0;
  left: 0;
`;

const Sorting = ({
  cats,
  currSort,
  currSortLabel,
  currCat,
  currCatLabel,
  setCurrCat,
  setCurrCatLabel,
  setCurrSort,
  setCurrSortLabel,
  isEn,
  location,
  contextData,
  contextSet,
}) => {
  const selectEl = useRef(null);

  const handleButtonClick = () => {
    contextSet({ smallProjects: !contextData.smallProjects });
  };

  useEffect(() => {
    const queryString = qs.parse(location.search);

    if (queryString && queryString.cat) {
      
      selectEl.current.value = queryString.cat;
      setCurrCat(queryString.cat);
      
      if (queryString.cat === 'all') {
        setCurrCatLabel(isEn ? 'All' : 'Wszystkie');
      } else {
        const currOption = cats.find(el => el.slug === queryString.cat);
  
        if (currOption) {
          setCurrCatLabel(currOption.title);
        } 
      }
    }
  }, [location]);

  return (
    <Wrapper>
      <SelectWrapper
        onChange={e => {
          setCurrCat(e.target.value);
          setCurrCatLabel(e.target.selectedOptions[0].innerHTML);
        }}
      >
        <Label>{currCatLabel}</Label>
        <Select ref={selectEl}>
          <option value={''} disabled>{isEn ? 'Category' : 'Kategoria'}</option>
          <option value={'all'}>{isEn ? 'All' : 'Wszystkie'}</option>
          {cats.map((item, i) => {
            return (
              <option key={i} value={item.slug}>
                {item.title}
              </option>
            );
          })}
        </Select>
        <Arrow />
      </SelectWrapper>
      <SelectWrapper>
        <Label>{currSortLabel}</Label>
        <Select
          onChange={e => {
            setCurrSort(e.target.value);
            setCurrSortLabel(e.target.selectedOptions[0].innerHTML);
          }}
        >
          <option value={''}>{isEn ? 'Sort by' : 'Sortuj'}</option>
          <option value={'a-z'}>A-Z</option>
          <option value={'z-a'}>Z-A</option>
        </Select>
        <Arrow />
      </SelectWrapper>
      <SizeButton onClick={handleButtonClick} type="button">
        <SizeButtonInner>
          <Bar size="s" mob />
          <Bar size="s" mob />
          <Bar size="s" mob />
          <Bar size="s" mob />
          <Bar size="s" />
          <Bar size="s" />
        </SizeButtonInner>
        <SizeButtonInner>
          <Bar mob />
          <Bar mob />
          <Bar />
        </SizeButtonInner>
      </SizeButton>
      <BottomGradient />
    </Wrapper>
  );
};

export default Sorting;
